module.exports = __webpack_public_path__ + "static/dev-52f34816d77b4d1416d36938b39b4197.svg";